import { axios } from 'configs'
import type { TTag, TUpsertTagRequest } from 'types'

export const listTags = async (): Promise<TTag[]> => {
  const response = await axios.get<TTag[]>('/tags')
  return response.data
}

export const createTag = async (
  request: TUpsertTagRequest,
): Promise<TTag> => {
  const response = await axios.post<TTag>('/tags', request)
  return response.data
}

export const updateTag = async (
  tagId: number,
  request: TUpsertTagRequest,
): Promise<TTag> => {
  const response = await axios.put<TTag>(`/tags/${tagId}`, request)
  return response.data
}

export const deleteTag = async (tagId: number): Promise<boolean> => {
  const response = await axios.delete<boolean>(`/tags/${tagId}`)
  return response.data
}
